import React from "react";

import { Box, Skeleton, Stack } from "@mui/material";

/**
 * Loading skeleton for shared experiment analytics
 * Shows placeholder UI while data is being fetched
 */
export const ShareLoadingSkeleton = () => {
  return (
    <Box sx={{ maxWidth: "1400px", margin: "0 auto", py: 4, px: 3 }}>
      <Stack spacing={4}>
        {/* Title skeleton */}
        <Skeleton variant="text" width="40%" height={40} />

        {/* Charts skeleton */}
        <Stack spacing={3}>
          {[1, 2, 3].map((i) => (
            <Box key={i}>
              <Skeleton variant="text" width="30%" height={32} sx={{ mb: 2 }} />
              <Skeleton
                variant="rectangular"
                width="100%"
                height={300}
                sx={{ borderRadius: 2 }}
              />
            </Box>
          ))}
        </Stack>
      </Stack>
    </Box>
  );
};
